import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	productAccessItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-access-item',
		defaultMessage: 'Product access',
		description: 'Navigation item which links to a product access settings page',
	},
	productAccessItemAppify: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-access-item-appify',
		defaultMessage: 'App access',
		description: 'Navigation item which links to a product access settings page',
	},
});
